import MadUpPro from './MadUpPro';

export default MadUpPro;